@if (visible) {
    <div class="debug-actions-bar">
        <button
            class="debug-actions-bar__btn"
            [class.debug-actions-bar__btn--active]="panel.open()"
            pTooltip="Show debug data"
            tooltipPosition="right"
            (click)="togglePanel()"
        >
            <i class="pi pi-code"></i>
        </button>
        <button
            class="debug-actions-bar__btn"
            pTooltip="Resync GC design (GET /sync-gc-design)"
            tooltipPosition="right"
            [disabled]="resyncing()"
            (click)="resyncGcDesign()"
        >
            <i class="pi pi-refresh" [class.pi-spin]="resyncing()"></i>
        </button>
        @for (action of panel.actions(); track action.id) {
            <button class="debug-actions-bar__btn" [pTooltip]="action.label" tooltipPosition="right" (click)="action.run()">
                <i [class]="'pi ' + (action.icon || 'pi-bolt')"></i>
            </button>
        }
    </div>

    @if (panel.open()) {
        <div class="debug-panel">
            <div class="debug-panel__tabs">
                @for (tab of panel.tabs(); track tab.id) {
                    <button class="debug-panel__tab" [class.debug-panel__tab--active]="panel.activeTabId() === tab.id" (click)="selectTab(tab.id)">
                        {{ tab.label }}
                    </button>
                }
                <button class="debug-panel__copy" (click)="copyToClipboard()" [title]="panel.copied() ? 'Copied!' : 'Copy JSON'">
                    <i [class]="panel.copied() ? 'pi pi-check' : 'pi pi-copy'"></i>
                </button>
            </div>
            <div class="debug-panel__content">
                <app-json-tree [value]="activeTabData()" />
            </div>
        </div>
    }
}
